import React, { useState, createContext, useContext } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const ClientAuthContext = createContext(null);

export function useClientAuth() {
  return useContext(ClientAuthContext);
}

export function ClientAuthProvider({ children }) {
  const [clientUser, setClientUser] = useState(null);
  const [loading, setLoading] = useState(false);

  const clientLogout = () => {
    localStorage.removeItem('threebie_client_token');
    setClientUser(null);
    window.location.href = '/client-login';
  };

  const clientLogin = async (email, password) => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/auth/client/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.detail || 'Login failed');
      }
      
      return data;
    } finally {
      setLoading(false);
    }
  };

  const verify2FA = async (token, totpCode) => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/auth/client/verify-2fa`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, totp_code: totpCode }),
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.detail || '2FA verification failed');
      }
      
      // Store token and user
      localStorage.setItem('threebie_client_token', data.access_token);
      setClientUser(data.user);
      
      return data;
    } finally {
      setLoading(false);
    }
  };

  const changePassword = async (token, currentPassword, newPassword) => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/auth/client/change-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          current_password: currentPassword,
          new_password: newPassword,
        }),
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.detail || 'Password change failed');
      }
      
      return data;
    } finally {
      setLoading(false);
    }
  };

  return (
    <ClientAuthContext.Provider value={{
      clientUser,
      setClientUser,
      loading,
      clientLogin,
      verify2FA,
      changePassword,
      clientLogout,
    }}>
      {children}
    </ClientAuthContext.Provider>
  );
}

export default ClientAuthContext;
